// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"280":"7ae21eec","781":"ee990f26","845":"1a976f7d","990":"539ae1f4"}[chunkId] + ".chunk.js";
};